module.exports = __webpack_public_path__ + "static/img/nfclass_logo.0c4a260.0c4a2602.png";